import { IconButton, useTheme } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

type Props = {
  onClick: () => void;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
};

export const DeleteTestPointButton = ({
  onClick,
  size = 'small',
  disabled = false
}: Props) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <IconButton
      onClick={onClick}
      size={size}
      disabled={disabled}
      aria-label="Delete test point"
      sx={{
        color: isDarkMode ? 'rgba(244, 67, 54, 0.6)' : 'error.main',
        '&:hover': {
          backgroundColor: 'rgba(244, 67, 54, 0.08)',
          color: isDarkMode ? 'rgba(244, 67, 54, 0.8)' : 'error.dark'
        },
        p: 0.5
      }}
    >
      <DeleteIcon fontSize={size} />
    </IconButton>
  );
};

export default DeleteTestPointButton;
